module.exports = __webpack_public_path__ + "img/no-task.2649d2bd.svg";